import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import useAuthRole from '../../hooks/useAuthRole';

export default function SystemAdminRoute({redirectTo = '/dashboard'}) {
    const {isPlatformAdmin, isRoleLoading} = useAuthRole();

    if (isRoleLoading) return <div className="api-message">در حال بررسی سطح دسترسی...</div>;
    return isPlatformAdmin ? <Outlet/> : <Navigate to={redirectTo} replace/>;
}
